import { useSocket } from '../socket/SocketProvider.js';

const LABELS: Record<string, string> = {
  connected: 'Live',
  connecting: 'Connecting…',
  disconnected: 'Offline',
  error: 'Disconnected',
};

const VARIANTS: Record<string, string> = {
  connected: 'connected',
  connecting: 'connecting',
  disconnected: 'down',
  error: 'down',
};

/**
 * Compact realtime indicator in the header.
 *
 * When chat stops updating, the first question is always whether the socket is
 * up. The label collapses to the dot alone on a phone, where the header has no
 * room for it and the colour already carries the state.
 */
export function ConnectionStatus() {
  const { status, error } = useSocket();
  const tone = status === 'connected' ? 'ok' : status === 'connecting' ? 'pending' : 'bad';
  const variant = VARIANTS[status] ?? 'down';
  const label = LABELS[status] ?? status;

  return (
    <span className={`pill connection connection--${variant}`} title={error ?? label}>
      <span className={`dot dot--${tone}`} />
      <span className="connection-label">{label}</span>
    </span>
  );
}
